<template>
  <v-card>
    <expert-header :expert="expert"></expert-header>
    <v-tabs grow centered dark scroll-bars>
      <v-divider></v-divider>
      <v-tabs-bar class="grey lighten-5" slot="activators">
        <v-tabs-item
          v-for="tab in tabs" :key="tab.key"
          router
          :href="{ name: 'Account', params: { tab: tab.key } }"
          ripple>
          {{ $t(`pages.account.tabs.${tab.key}`) }}
        </v-tabs-item>
      </v-tabs-bar>
    </v-tabs>
    <v-divider></v-divider>
    <v-progress-linear v-if="loading" indeterminate height="2"></v-progress-linear>
    <v-card flat>
      <v-card-text>
        <component :is="currentTab.component" :expert="expert"></component>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { ExpertHeader } from '@/components/expert'
  import {
    AccountInformations,
    AccountSchedule
  } from '@/components/account'
  import ExpertProfile from '@/components/expert/Profile'
  export default {
    components: {
      ExpertHeader
    },
    props: {
      tab: {
        type: String,
        default: () => this.tabs[0].key
      }
    },
    computed: {
      ...mapGetters({
        platform: 'skiliko/session/currentPlatform',
        expert: 'skiliko/session/currentUser',
        loading: 'skiliko/session/isLoading'
      }),
      tabs () {
        return [
          { key: 'profile', component: ExpertProfile },
          { key: 'informations', component: AccountInformations },
          { key: 'schedule', component: AccountSchedule }
        ]
      },
      currentTab () {
        return this.tabs.filter(tab => tab.key === this.tab)[0]
      }
    }
  }
</script>

<style scoped>
  .progress-linear { margin: 0; }
</style>



// WEBPACK FOOTER //
// src/pages/Account.vue